export const ADMINISTRATIVE_DIVISION_API_ENDPOINT = 'communes';
